export const MenuItems = () => [
  {
    moduleName: 'Master Data',
    orderNo: 1,
    url: '/masterdata',
  },
  {
    moduleName: 'Employee',
    orderNo: 2,
    url: '/employee',
  },
  {
    moduleName: 'Delinquency',
    orderNo: 3,
    url: '/delinquency',
  },
  {
    moduleName: 'Sub-Admin',
    orderNo: 4,
    url: '/subadmin',
  },
]

export const AdminMenuItems = () => [
   {
    moduleName: 'Dashboard',
    orderNo: 1,
    url: '/dashboard',
  },
  {
    moduleName: 'Master Data',
    orderNo: 2,
    url: '/masterdata',
  },
  {
    moduleName: 'Sub-Unit Admins',
    orderNo: 4,
    url: '/subadmin',
  },
   {
    moduleName: 'Transfer Employee',
    orderNo: 5,
    url: '/transfer',
  },
  
     {
    moduleName: 'Reports',
    orderNo: 6,
    url: '/report',
  },
   
]

export const UnitAdminItems = () => [
  {
    moduleName: 'Employee',
    orderNo: 1,
    url: '/employee',
  },
  {
    moduleName: 'Delinquency',
    orderNo: 2,
    url: '/delinquency',
  },
 {
    moduleName: 'Transfer Employee',
    orderNo: 3,
    url: '/transfer',
  },
  {
    moduleName: 'Reports',
    orderNo: 4,
    url: '/report',
  },
]
